export const useAllOpenLayerAssets = (
  assets: Ref<Array<MapAsset> | undefined>,
  mainAsset: Ref<LookupAsset | undefined>,
  mainRelatedAssets: Ref<Array<LookupAsset>>,
  selectedRelatedAssets: Ref<Array<LookupAsset>>,
) => {
  const allAssets = computed<Array<MapAsset>>(() => {
    const assetsToInclude: Array<MapAsset> = []

    if (assets.value?.length) {
      assetsToInclude.push(...assets.value.filter((asset) => assetsToInclude.every((markAsset) => asset._id !== markAsset._id)))
    }

    if (mainAsset.value && !assets.value?.some((asset) => asset._id === mainAsset.value?._id)) {
      assetsToInclude.push(mainAsset.value)
    }

    if (mainAsset && mainRelatedAssets.value) {
      assetsToInclude.push(...mainRelatedAssets.value.filter((asset) => assetsToInclude.every((markAsset) => asset._id !== markAsset._id)))
    }

    if (selectedRelatedAssets.value) {
      assetsToInclude.push(
        ...selectedRelatedAssets.value.filter((asset) => assetsToInclude.every((markAsset) => asset._id !== markAsset._id)),
      )
    }

    return assetsToInclude
  })

  return { allAssets }
}
